import { FC, ReactNode } from 'react';
import styles from './TableFigure.module.sass';

interface TableFigureProps {
  figure?: ReactNode;
  note?: ReactNode;
  className?: string;
}

const TableFigure: FC<TableFigureProps> = (props) => {
  const { figure, note, className } = props;

  return (
    <div className={`${styles.totals} ${className || ''}`}>
      {!!note && <div className={styles.note}>{note}</div>}
      {!note && <div className={styles.note}>&nbsp;</div>}
      <div className={styles.inner}>
        <span className={styles.label}>{figure}</span>
      </div>
    </div>
  );
};

export default TableFigure;
